import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { LoadingPanel } from "../../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { checkAcessRights, formatIndianNumber } from "../../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../../_contstants/common";
import AlertBox from "../../../components/common/AlertBox";
import { GetMonthlyRevenueTrendReport } from "../services/reports.services";
import moment from "moment";

const MonthlyRevenueTrendReportView = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  // const navigate = useNavigate();
  const params = useParams();
  const isExcelExportAccess = checkAcessRights(
    "/monthlyrevenuetrendreportform",
    EXCEL_EXPORT_ACCESS
  );
  const isPrintAccess = checkAcessRights(
    "/monthlyrevenuetrendreportform",
    PRINT_ACCESS
  );

  const filterYear = params?.filterYear;
  const Destination = params?.Destination;
  const filterUserID = params?.filterUserID;
  const BranchID = params?.BranchID;

  const loading = useAppSelector((state) => state.reports.loading);
  const MonthlyRevenueTrendListForReport = useAppSelector(
    (state) => state.reports.MonthlyRevenueTrendListForReport
  );

  const [uiLoading, setLoading] = React.useState<boolean>(true);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (filterYear) {
      const payload = {
        Year: filterYear !== "0" ? filterYear : "",
        Destination: Destination !== "0" ? Destination : "",
        UserID: filterUserID !== "0" ? filterUserID : 0,
        BranchID: BranchID !== "0" ? BranchID : 0,
      };
      dispatch(GetMonthlyRevenueTrendReport(payload));
    }
  }, []);

  // const handleExportExcel = () => {
  //   const wb = XLSX.utils.book_new();
  //   const ws = XLSX.utils.table_to_sheet(
  //     document.querySelector(".table-bordered")
  //   );
  //   XLSX.utils.book_append_sheet(wb, ws, "MonthlyRevenueTrendReport");

  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const data = new Blob([excelBuffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });
  //   saveAs(
  //     data,
  //     `monthlyrevenuetrendreport${filterYear ? `-${filterYear}` : ""}.xlsx`
  //   );
  // };

  // const handleExportExcel = () => {
  //   const table = document.querySelector(".table-bordered");
  //   const rows = table.querySelectorAll("tr");
  //   const data = [];

  //   // Convert table to array with formatted dates
  //   rows.forEach((row) => {
  //     const rowData = [];
  //     const cells = row.querySelectorAll("td, th");

  //     cells.forEach((cell, index) => {
  //       if (
  //         cell.classList.contains("text-center") &&
  //         cell.textContent.includes(",")
  //       ) {
  //         // This is likely a date cell, parse and format for Excel
  //         const date = moment(cell.textContent, "MMM, YYYY");
  //         if (date.isValid()) {
  //           rowData.push({
  //             v: date.toDate(),
  //             t: "d",
  //             z: "mmm, yyyy",
  //           });
  //         } else {
  //           rowData.push(cell.textContent);
  //         }
  //       } else {
  //         rowData.push(cell.textContent);
  //       }
  //     });

  //     data.push(rowData);
  //   });

  //   const ws = XLSX.utils.aoa_to_sheet(data);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "MonthlyRevenueTrendReport");

  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const blob = new Blob([excelBuffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });
  //   saveAs(
  //     blob,
  //     `monthlyrevenuetrendreport${filterYear ? `-${filterYear}` : ""}.xlsx`
  //   );
  // };

  const handleExportExcel = () => {
    const table = document.querySelector(".table-bordered") as any;
    const rows = table.querySelectorAll("tr");
    const data: any = [];

    // Convert table to array with proper formatting
    rows.forEach((row: any) => {
      const rowData: any = [];
      const cells = row.querySelectorAll("td, th");

      cells.forEach((cell: any) => {
        const cellText = cell.textContent.trim();

        // Check if it's a header row
        const isHeader =
          row.tagName === "TR" && row.children[0].tagName === "TH";

        if (isHeader) {
          // For headers, just use the text
          rowData.push(cellText);
        } else {
          // For data cells, check the content type
          const isDateCell =
            cell.classList.contains("text-center") && cellText.includes(",");
          const isNumericCell = cell.classList.contains("number");

          if (isDateCell) {
            // This is a date cell (MMM, YYYY format)
            const date = moment(cellText, "MMM, YYYY");
            if (date.isValid()) {
              rowData.push({
                v: date.toDate(),
                t: "d",
                z: "mmm, yyyy",
              });
            } else {
              rowData.push(cellText);
            }
          } else if (isNumericCell && cellText) {
            // This is a numeric cell (e.g., "1,18,599.00")
            // Remove commas and convert to number
            const numericValue = parseFloat(cellText.replace(/,/g, ""));

            if (!isNaN(numericValue)) {
              rowData.push({
                v: numericValue,
                t: "n", // number type
                // z: "#,##0", // format with thousands separator and 2 decimal places
              });
            } else {
              rowData.push(cellText);
            }
          } else {
            // Regular text cell
            rowData.push(cellText);
          }
        }
      });

      data.push(rowData);
    });

    // Create worksheet from data
    const ws = XLSX.utils.aoa_to_sheet(data);

    // Add column widths for better formatting
    const wscols = [
      { wch: 12 }, // Date column
      { wch: 15 }, // Revenue column
      { wch: 15 }, // Another numeric column if exists
      // Add more as needed based on your table structure
    ];
    ws["!cols"] = wscols;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "MonthlyRevenueTrendReport");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(
      blob,
      `monthlyrevenuetrendreport${filterYear ? `-${filterYear}` : ""}.xlsx`
    );
  };

  if (uiLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div
        className="report-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 10px",
        }}
      >
        <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
          Monthly Revenue Trend Report{" "}
          <span style={{ fontSize: 15 }}>
            {MonthlyRevenueTrendListForReport &&
              MonthlyRevenueTrendListForReport.length > 0 &&
              (filterYear || "")}
          </span>
        </Typography.h4>
        <div className="printbuttons">
          {isPrintAccess &&
            MonthlyRevenueTrendListForReport &&
            MonthlyRevenueTrendListForReport.length > 0 && (
              <Button
                style={{ marginRight: 5 }}
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={() => window.print()}
              >
                Print
              </Button>
            )}

          {isExcelExportAccess &&
            MonthlyRevenueTrendListForReport &&
            MonthlyRevenueTrendListForReport.length > 0 && (
              <Button
                type="button"
                fillMode={"solid"}
                themeColor={"primary"}
                onClick={handleExportExcel}
              >
                Excel Export
              </Button>
            )}
        </div>
      </div>
      {MonthlyRevenueTrendListForReport &&
      MonthlyRevenueTrendListForReport.length > 0 ? (
        <div className="table-responsive" style={{ margin: "0 10px" }}>
          <table className="table table-bordered reportScreens lead-report">
            <thead>
              <tr>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  No
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Month Year
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Total Inquiries
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Total Booking
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-end"
                >
                  Revenue Generated
                </th>
                <th
                  style={{ background: "black", color: "white" }}
                  className="text-center"
                >
                  Conversion (%)
                </th>
              </tr>
            </thead>
            <tbody>
              {MonthlyRevenueTrendListForReport &&
                MonthlyRevenueTrendListForReport.length > 0 &&
                MonthlyRevenueTrendListForReport?.map(
                  (MonthlyRevenueTrend: any, index: number) => (
                    <tr key={index}>
                      <td className="text-center number">{index + 1}</td>
                      <td className="text-center">
                        {moment(
                          MonthlyRevenueTrend?.MonthYear,
                          "MMMM-YYYY"
                        ).format("MMM, YYYY")}
                      </td>
                      <td className="text-end number">
                        {MonthlyRevenueTrend?.TotalInquiries || ""}
                      </td>
                      <td className="text-center number">
                        {MonthlyRevenueTrend?.TotalBookings || ""}
                      </td>
                      <td className="text-end number">
                        {MonthlyRevenueTrend?.RevenueGenerated
                          ? formatIndianNumber(
                              +MonthlyRevenueTrend?.RevenueGenerated
                            )
                          : ""}
                      </td>
                      <td className="text-center number">
                        {MonthlyRevenueTrend?.ConversionPer || ""}
                      </td>
                    </tr>
                  )
                )}
            </tbody>
          </table>
        </div>
      ) : (
        <AlertBox style={{ margin: "0 10px 10px" }} />
      )}
    </>
  );
};

export default MonthlyRevenueTrendReportView;
